<template>
    <v-list-tile>
        <v-dialog v-model="mostrarDialogExclusao" persistent max-width="290">
            <v-list-tile-title slot="activator">
                <i class="fas fa-trash-alt mr-2" aria-hidden="true"/>
                Excluir
            </v-list-tile-title>
            <mensagem-confirmacao :exibirMensagem="mostrarDialogExclusao"
                                  textoSecundario="Deseja realmente excluir a compra direta?"
                                  tamanhoMaximo="320"
                                  @confirmado="excluir"
                                  @recusado="mostrarDialogExclusao = false"/>
        </v-dialog>
    </v-list-tile>
</template>

<script>
export default {
    name: 'AcoesExcluir',
    data() {
        return {
            mostrarDialogExclusao: false
        }
    },
    methods: {
        excluir() {
            this.mostrarDialogExclusao = false
            this.$emit('excluirCompraDireta')
        }
    }
}
</script>

<style scoped lang="stylus">
    .v-dialog__container
        width 100%
</style>
